/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDiamond = createReactComponent("diamond", "IconDiamond", [
  [
    "path",
    { d: "M6 5h12l3 5l-8.5 9.5a.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5", key: "svg-0" }
  ],
  ["path", { d: "M10 12l-2 -2.2l.6 -1", key: "svg-1" }]
]);

export { IconDiamond as default };
//# sourceMappingURL=IconDiamond.js.map
